<template>
    <modal @modal-close="$emit('close')">

        <div class="modal-wrapper">

            <CloseButton @click="$emit('close')" />

            <div class="modal-content">
                <div class="item">
                    <h4>{{ $t("Title") }}</h4>
                    <p>{{ inspection.checklist_title }}</p>
                </div>

                <div class="item" v-if="inspection.description">
                    <h4>{{ $t("Description") }}</h4>
                    <p class="whitespace-pre-line">{{ inspection.description }}</p>
                </div>

                <div class="item">
                    <h4>{{ $t("Conducted at") }}</h4>
                    <p>{{ $du(inspection.conducted_at, 'shortDateTime') }}</p>
                </div>

                <div class="item" v-if="inspection.conducted_by">
                    <h4>{{ $t("Conducted by") }}</h4>
                    <p>{{ inspection.conducted_by }}</p>
                </div>

                <div class="item" v-if="inspection.site && inspection.sites[inspection.site]">
                    <h4>{{ $t("Site") }}</h4>
                    <p>{{ inspection.sites[inspection.site] }}</p>
                </div>

                <div class="item" v-if="inspection.due_at">
                    <h4>{{ $t("Due date") }}</h4>
                    <p>{{ $du(inspection.due_at, 'shortDateTime') }}</p>
                </div>

            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                    <button
                        v-if="inspection.authorized_to_edit"
                        type="button"
                        class="modal-actions-secondary"
                        @click.prevent="$emit('edit')"
                        >
                        {{ $t('Edit responses') }}
                    </button>

                    <button
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="$emit('show')">
                            {{ $t('See report') }}
                    </button>
                </div>
            </div>

        </div>

    </modal>
</template>

<script>
import CloseButton from '@/components/Modals/CloseButton.vue';

export default {
    components: { CloseButton },

    props: {
        inspection: {
            type: Object,
            required: true,
        },
    },

};
</script>
